import { MY_REWARDS } from '../ids';
import { InstallLocation } from '../types';
export const ids = MY_REWARDS;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Standalone,
    method: 'addApplication',
    social: false,
    showInLoginMenu: true,
    urlOverride: 'my-rewards',
    uninstallable: true,
    page: {
        name: t('editor.my-rewards-page.name'),
        shortDescription: t('editor.my-rewards-page.short-description'),
        description: t('editor.my-rewards-page.description'),
        iconURL: `${staticsUrl}/assets/images/icons/loyalty.png`,
        origin: t('editor.my-rewards-page.origin'),
        isNew: true,
        screenshots: [
            `${staticsUrl}/assets/images/my-rewards/my-rewards.png`,
            `${staticsUrl}/assets/images/my-rewards/my-rewards-mobile.png`,
            `${staticsUrl}/assets/images/my-rewards/my-rewards-mobile-2.png`,
        ],
    },
});
//# sourceMappingURL=my-rewards.js.map